<template lang="pug">
div
  .service-limit
    div.text-lg.font-medium.neutral700--text.mt-8 {{ $t('opt_in_booking') }}
    div.text-sm.neutral500--text {{ $t('opt_in_booking_description') }}

    div.text-md.neutral700--text.mt-4 {{ $t('approve_booking_auto') }}

    v-radio-group(v-model="autoApproval" :disabled="disabled")
      .d-flex.align-start
        v-radio.ma-0(:value="true" color="neutral700")
        div.clickable(@click="autoApproval = true")
          div.text-md.font-normal.neutral700--text {{ $t('yes_approve') }}
          div.text-sm.font-normal.neutral500--text {{ $t('yes_approve_description') }}
      .d-flex.align-start.mt-2
        v-radio.ma-0(:value="false" color="neutral700")
        div.clickable(@click="autoApproval = false")
          div.text-md.font-normal.neutral700--text {{ $t('no_approve') }}
          div.text-sm.font-normal.neutral500--text {{ $t('no_approve_description') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ServiceSettings',
  components: {  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      autoApproval: true
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      service: 'clinic/getService',
    }),
    requestData () {
      return {
        auto_approval: this.autoApproval
      }
    }
  },
  watch: {
    requestData: {
      deep: true,
      handler (val) {
        if (this.disabled) return
        this.$store.commit('clinic/updateTempService', val)
      }
    }
  },
  mounted () {
    if (this.service) {
      this.setData(this.service)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    setData (service) {
      this.autoApproval = service.auto_approval
    },
  }
}
</script>

<style scoped>
</style>